import { createSelector } from 'reselect';

export const apiBaseUrlSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'api']);
export const currentYearSelector = (state) =>
  state.getIn(['app', 'global', 'currentYear']);
export const importStatusSelector = (state) =>
  state.getIn(['app', 'global', 'importStatus']);
export const officeSelector = (state) =>
  state.getIn(['app', 'global', 'configuration', 'urls', 'office']);
export const clientConfigSelector = (state) =>
  state.getIn(['app', 'global', 'clientConfig']);
export const searchResultConfigSelector = (state) =>
  state.getIn(['app', 'global', 'searchResultConfig']);
export const propertyListSelector = (state) =>
  state.getIn(['app', 'global', 'propertyList']);
export const propertySelector = (state) =>
  state.getIn(['app', 'global', 'property']);
export const taxingUnitSelector = (state) =>
  state.getIn(['app', 'global', 'taxingUnit']);
export const tokenSelector = (state) => state.getIn(['app', 'global', 'token']);
export const queryStringSelector = (state) =>
  state.getIn(['app', 'global', 'queryString']);
export const userSelector = createSelector(
  [(state) => state.getIn(['app', 'global', 'user'])],
  (user) => user.toJS(),
);
